import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React from 'react';

interface Props {
	results: any;
}

const ReportTable = (props: Props) => {
	const { results } = props;

	if (!results) {
		return null;
	}

	const renderHeaders = () => {
		const cells = results.headers.map((h: string) => {
			return <TableCell key={h}>{h}</TableCell>;
		});
		return cells;
	};

	const renderRows = () => {
		return results.previewRows.map((r: string[], rowIndex: number) => {
			const cells = r.map((c: string, colIndex: number) => {
				const cIsNum = !isNaN(parseFloat(c));
				return (
					<TableCell
						style={{ textAlign: cIsNum ? 'right' : 'center' }}
						key={`${rowIndex}-${colIndex}`}
					>
						{c}
					</TableCell>
				);
			});
			return <TableRow key={rowIndex}>{cells}</TableRow>;
		});
	};

	if (!results.previewRows.length) {
		return (
			<h4 style={{ marginTop: '50px', textAlign: 'center' }}>
				Your report returned no results. Please change your filter criteria and
				try again.
			</h4>
		);
	}

	return (
		<div style={{ marginTop: '50px', overflow: 'auto', whiteSpace: 'nowrap' }}>
			<h5>Returned {results.previewRows.length} results</h5>
			<TableContainer>
				<Table size='small'>
					<TableHead>
						<TableRow>{renderHeaders()}</TableRow>
					</TableHead>
					<TableBody>{renderRows()}</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

export default ReportTable;
